import { RiskIncidentOverviewSectionWebComponent } from '../../riskIncidentOverviewSection/component/RiskIncidentOverviewSectionWebComponent';
import { RiskIncidentOverviewSectionRow } from '../../riskIncidentOverviewSection/types';

export const CLOUD_SECURITY_NUMBER_OF_ITEMS = 5;

export const ERA_NUMBER_OF_ITEMS = 5;

export const ROOT_CAUSE_NUMBER_OF_ITEMS = 2;

export const MAX_WIDTH_CHART = 400;

export enum ErrorCodes {
  CSPM_LICENSE_NOT_FOUND = 1,
}

export interface SectionsItems {
  section: RiskIncidentOverviewSectionWebComponent;
  key: RisksSectionsStrings;
}

export interface RisksSections {
  cloudSecurity: RiskIncidentOverviewSectionRow[];
  riskManagement: RiskIncidentOverviewSectionRow[];
  rootCause: RiskIncidentOverviewSectionRow[];
}

export enum RisksIncidentOverviewEvents {
  VIEW_ALL_RISKS = 'viewAllRisks',
}

export enum CloudSecuritySectionEvents {
  CLICK_ON_GET_LICENSE = 1,
}

export enum RisksSectionsStrings {
  cloudSecuritySection = 'cloudSecurity',
  eraSection = 'riskManagement',
  rootCause = 'rootCause',
}
